import { Vue, Options } from 'vue-class-component';
import { PropType } from 'vue';
import {
  ActionDTO,
  ConditionDTO,
  TriggerDTO,
} from '@/../client-generator/generated-clients/plants';

import { getSceneObjectIconFromType } from '@/core/utils/utils';
import { SceneUtils } from '@/core/utils/scene.utils';
import Draggable from 'vuedraggable';
import SceneListItem from '../SceneStepItemsList/SceneListItem/SceneListItem.vue';

@Options({
  name: 'DialogSceneStepItemsListReorder',
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
    items: {
      type: Array as PropType<ActionDTO[] | TriggerDTO[] | ConditionDTO[]>,
    },
  },
  components: {
    Draggable,
    SceneListItem,
  },
  watch: {
    isVisible: function (newValue) {
      this.isDialogVisible = newValue;
      if (newValue) this.prepareItems();
    },
    isDialogVisible: function (newValue) {
      this.$emit('update:isVisible', newValue);
    },
  },
  emits: ['confirm', 'update:isVisible'],
})
export default class DialogSceneStepItemsListReorder extends Vue {
  items!: ActionDTO[];
  itemsReordered: ActionDTO[] = [];
  getSceneObjectIconFromType = getSceneObjectIconFromType;
  SceneUtils = SceneUtils;

  isVisible!: boolean;
  isDialogVisible = false;

  created() {
    this.isDialogVisible = this.isVisible;
    this.prepareItems();
  }

  prepareItems() {
    this.itemsReordered = [];
    this.items.forEach((k) => this.itemsReordered.push(new ActionDTO(k)));
  }

  doHideDialog() {
    this.isDialogVisible = false;
  }

  doConfirm() {
    this.$emit('confirm', this.itemsReordered);
    this.doHideDialog();
  }
}
